import { AclEntryCondition } from 'common/types/Entities';

const HISTORICAL_START_DATE = 'historicalStartDate';
const HISTORICAL_DAYS_BACK = 'historicalDaysBack';

export const getConditionsToDisplay = (conditions: AclEntryCondition[] | undefined): string => {
    return conditions == undefined ? '' :  conditions.map(formatAclCondition).filter(Boolean).join(', ');
};

const formatAclCondition = (condition: AclEntryCondition): string => {
    const { conditionKey, parameters } = condition;

    switch (conditionKey) {
        case HISTORICAL_START_DATE: {
            const { startDate } = parameters as { startDate: string };
            return `Start: ${startDate}`;
        }

        case HISTORICAL_DAYS_BACK: {
            const { daysBack } = parameters as { daysBack: string | number };
            return `Days: ${daysBack}`;
        }

        default:
            return '';
    }
};
